'use client';

import type { PostHog as Posthog_Client } from 'posthog-js';
import type { PostHog_Features } from './shared';
import { PostHog_OVERRIDES } from './shared';

export class PostHog_ClientFeaturesSDK {
    static getFlag<T extends PostHog_Features.Name>(
        client: Posthog_Client,
        key: T,
        fallback?: PostHog_Features.Variant<T>,
    ): PostHog_Features.Variant<T> | null {
        // Check for local overrides first
        if (PostHog_OVERRIDES[key]) {
            return PostHog_OVERRIDES[key];
        }

        if (!client?.__loaded) {
            return fallback ?? null;
        }

        const flagValue = client.getFeatureFlag(key) as PostHog_Features.Variant<T> | undefined;
        return flagValue ?? fallback ?? null;
    }
}
